const authCodes = {
  INVALID_EMAIL: 'auth/invalid-email',
  USER_NOT_FOUND: 'auth/user-not-found',
  WRONG_PASSWORD: 'auth/wrong-password',
  WEAK_PASSWORD: 'auth/weak-password',
};


export const authFlowEvents = {
  RECAPTCHA_COMPLETED: 'RECAPTCHA_COMPLETED',
  INVALID_APP_CREDENTIAL: 'INVALID_APP_CREDENTIAL',
  MFA_START_SUCCESS: 'MFA_START_SUCCESS',
  OTP_INITIATED: 'OTP_INITIATED',
  OTP_INVALID: 'OTP_INVALID',
  RECAPTCHA_CHALLENGE_COUNT: 'RECAPTCHA_CHALLENGE_COUNT',
};

export const loginFailureReason = {
  TOO_MANY_REQUESTS: 'Too many requests',
  WRONG_CREDENTIALS: "Wrong email or password",
  TWO_FACTOR_ERROR: "Two factor error",
  TWO_FACTOR_WRONG_CODE:"Two factor wrong code",
  NOT_FOUND: "User not found"
}

export default authCodes;
